import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';

import TicketForm from '@components/tickets/TicketForm';

const CreateTicketPage = () => {
  useEffect(() => {
    document.title = 'Create Ticket - RDX Ticketing System';
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.3,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.3 }
    }
  };

  return (
    <motion.div
      className="space-y-6"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      {/* Header */}
      <motion.div variants={itemVariants}>
        <div className="bg-white p-6">
          <div className="flex items-center gap-4">
            <Link
              to="/tickets"
              className="flex items-center justify-center w-10 h-10 transition-colors"
              aria-label="Back to tickets"
            >
              <ArrowLeft className="w-5 h-5 text-gray-600" />
            </Link>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Create New Ticket</h1>
              <p className="text-gray-600 mt-1">
                Submit a support request or report an issue
              </p>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Ticket Form */}
      <motion.div variants={itemVariants}>
        <TicketForm mode="create" />
      </motion.div>
    </motion.div>
  );
};

export default CreateTicketPage;
